const DEFAULT_FONT_DISPLAY = 'swap';
const unsupportedFontLocales = ['vi-vn', 'az-az'];
export function isUnsupportedFontLocale(locale) {
  return typeof locale === 'string' && unsupportedFontLocales.includes(locale.toLowerCase());
}
export const fonts = [
// Volvo Broad
{
  fontFamily: 'Volvo Broad',
  fontWeight: 400,
  fontDisplay: DEFAULT_FONT_DISPLAY,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-broad/volvo-broad-cyrillic.woff2']
}, {
  fontFamily: 'Volvo Broad',
  fontWeight: 400,
  fontDisplay: DEFAULT_FONT_DISPLAY,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-broad/volvo-broad-greek.woff2']
}, {
  fontFamily: 'Volvo Broad',
  fontWeight: 400,
  fontDisplay: DEFAULT_FONT_DISPLAY,
  unicodeRange: 'U+0020-036F, U+0530-FB02',
  src: ['volvo-broad/volvo-broad-latin-rest.woff2']
},
// Volvo Novum Semi Light
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-semi-light.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-semi-light.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  src: ['volvo-novum/volvo-novum-semi-light.woff2']
},
// Volvo Novum Semi Light Italic
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  fontStyle: 'italic',
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-semi-light-italic.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  fontStyle: 'italic',
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-semi-light-italic.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  fontStyle: 'italic',
  src: ['volvo-novum/volvo-novum-semi-light-italic.woff2']
},
// Volvo Novum Regular
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-regular.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-regular.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  src: ['volvo-novum/volvo-novum-regular.woff2']
},
// Volvo Novum Italic
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  fontStyle: 'italic',
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-italic.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  fontStyle: 'italic',
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-italic.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  fontStyle: 'italic',
  src: ['volvo-novum/volvo-novum-italic.woff2']
},
// Volvo Novum Medium
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-medium.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-medium.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  src: ['volvo-novum/volvo-novum-medium.woff2']
},
// Volvo Novum Medium Italic
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  fontStyle: 'italic',
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-medium-italic.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  fontStyle: 'italic',
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-medium-italic.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  fontStyle: 'italic',
  src: ['volvo-novum/volvo-novum-medium-italic.woff2']
},
// Volvo Novum Bold
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-bold.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-bold.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  src: ['volvo-novum/volvo-novum-bold.woff2']
},
// Volvo Novum Bold Italic
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  fontStyle: 'italic',
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-bold-italic.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  fontStyle: 'italic',
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-bold-italic.woff2']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  fontStyle: 'italic',
  src: ['volvo-novum/volvo-novum-bold-italic.woff2']
}];